"use strict";
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.AddProductsToBasketResultDialog = void 0;
var _components = require("@ori-ui/components");
var _mui = require("@ori-ui/mui");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _contexts = require("../../contexts");
var _useTranslations = require("../../hooks/useTranslations");
var _constants = require("./constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const AddProductsToBasketResultDialog = (param)=>{
    let { countOfSuccessfullyAdded, open, onClose } = param;
    const { getTestId } = (0, _testidGenerator.default)();
    const { translations, formatMessage } = (0, _useTranslations.useTranslations)();
    const { products } = (0, _contexts.useDetailContext)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.Dialog, {
        open: open,
        onClose: onClose,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_styles.Root, {
            "data-testid": getTestId(_constants.ADD_PRODUCTS_TO_BASKET_RESULT_DIALOG),
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_styles.Inner, {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.SuccessIcon, {}),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)(_mui.Typography, {
                            variant: "h4",
                            component: "h4",
                            children: translations.addProductsToBagSuccessTitle
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)(_mui.Typography, {
                            children: formatMessage('addProductsToBagSuccessMsg', {
                                0: countOfSuccessfullyAdded,
                                1: products.length
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_styles.Inner, {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.Button, {
                            fullWidth: true,
                            variant: "contained",
                            color: "primary",
                            href: "/shopping/basket",
                            children: translations.goToBasket
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.Button, {
                            fullWidth: true,
                            variant: "outlined",
                            color: "default",
                            onClick: onClose,
                            children: translations.closeAddProductsToBagSuccessDialog
                        })
                    ]
                })
            ]
        })
    });
};
exports.AddProductsToBasketResultDialog = AddProductsToBasketResultDialog;
